module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Return of George Washington")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/9780062248695_template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "part",
      "title": "PART 1"
    }
  }, [_c('header', [_c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "h2p",
    attrs: {
      "id": "pa1"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rpa1"
    }
  }, [_vm._v("BOOK I")])])]), _vm._v(" "), _c('h2', {
    staticClass: "h2p1",
    attrs: {
      "id": "pa1a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rpa1a"
    }
  }, [_vm._v("From New York to Mount Vernon")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2y"
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rpa1a"
    }
  }, [_vm._v("1782–1786")])])]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('p', {
    staticClass: "image1"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "400",
      "src": "images/f002.jpg",
      "width": "284"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('i', [_vm._v("1782 print of General George Washington during the Revolutionary War.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17ff39fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062248695_Part_1.vue
// module id = 72
// module chunks = 0